import { connect } from 'react-redux';
import { actionCreators, selectors } from 'dux/instances';
import NodesTab from './NodesTab';

const mapStateToProps = (state) => ({
  getInstanceSpaceUsage: selectors.getInstanceSpaceUsage(state),
});

const mapDispatchToProps = {
  changeNodeQuantity: actionCreators.changeNodeQuantity,
};

export default connect(mapStateToProps, mapDispatchToProps)(NodesTab);
